import classNames from "classnames";
import React from "react";

import type { IconName } from "@const/enum";

import * as icons from "./svg";

interface IProps {
  name: IconName;
  width?: string;
  height?: string;
  alt?: string;
  className?: string | classNames.ArgumentArray;
  onClick?: () => void;
  fill?: string;
}

function Icon({ name, width = "14px", height = "14px", alt, className, ...props }: IProps) {
  const SVGLogo = icons[name];

  return (
    <>
      {alt ? <span className="sr-only">{alt}</span> : null}
      <SVGLogo className={classNames(className)} height={height} width={width} {...props} />
    </>
  );
}

export default Icon;
